/* SanoAlint – pagina principală: zone, file de produse, carusele și adăugare în coș. */
(function () {
  if (window.SAHome) return;
  var SAHome = (window.SAHome = {});
  var mobileQuery = window.matchMedia('(max-width: 989px)');
  var eventsModule = null;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ---------- Zonele corpului ---------- */
  function initZones(root) {
    each(root.querySelectorAll('[data-sa-zones]'), function (wrap) {
      if (wrap.getAttribute('data-sa-ready')) return;
      wrap.setAttribute('data-sa-ready', '1');

      function select(index) {
        each(wrap.querySelectorAll('[data-sa-zone]'), function (button) {
          var on = button.getAttribute('data-sa-zone') === index;
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          button.classList.toggle('is-active', on);
        });
        each(wrap.querySelectorAll('[data-sa-panel]'), function (panel) {
          panel.hidden = panel.getAttribute('data-sa-panel') !== index;
        });
      }

      wrap.addEventListener('click', function (event) {
        var button = event.target.closest('[data-sa-zone]');
        if (!button || !wrap.contains(button)) return;
        var index = button.getAttribute('data-sa-zone');
        select(index);

        if (button.hasAttribute('data-sa-zone-list') && mobileQuery.matches) {
          var panel = wrap.querySelector('[data-sa-panel="' + index + '"]');
          if (!panel) return;
          var rect = panel.getBoundingClientRect();
          if (rect.top > window.innerHeight - 120 || rect.bottom < 0) {
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });

      wrap.saSelect = select;
    });
  }

  /* ---------- Carusele ---------- */
  function initCarousels(root) {
    each(root.querySelectorAll('[data-sa-carousel]'), function (carousel) {
      if (carousel.getAttribute('data-sa-ready')) return;
      carousel.setAttribute('data-sa-ready', '1');

      var track = carousel.querySelector('[data-sa-track]');
      var nav = carousel.querySelector('[data-sa-nav]');
      var prev = carousel.querySelector('[data-sa-prev]');
      var next = carousel.querySelector('[data-sa-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('[data-sa-slide]');
        if (!slide) return track.clientWidth * 0.8;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        if (!nav) return;
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        nav.hidden = !scrollable;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      carousel.saUpdate = update;
      update();
    });
  }

  /* ---------- File de produse ---------- */
  function initTabs(root) {
    each(root.querySelectorAll('[data-sa-tabs]'), function (wrap) {
      if (wrap.getAttribute('data-sa-ready')) return;
      wrap.setAttribute('data-sa-ready', '1');

      var tabs = wrap.querySelectorAll('[role="tab"]');

      function activate(tab, focus) {
        each(tabs, function (item) {
          var on = item === tab;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !on;
            if (on) {
              var carousel = panel.querySelector('[data-sa-carousel]');
              if (carousel && carousel.saUpdate) carousel.saUpdate();
            }
          }
        });
        if (focus) tab.focus();
      }

      each(tabs, function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var target = null;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) {
            event.preventDefault();
            activate(target, true);
          }
        });
      });
    });
  }

  /* ---------- Adăugare în coș ---------- */
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = import('@shopify/events').catch(function () {
        return null;
      });
    }
    return eventsModule;
  }

  function cartUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
  }

  function cartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function refreshCart() {
    var component = document.querySelector('cart-items-component');
    if (component && window.customElements) {
      return window.customElements.whenDefined('cart-items-component').then(function () {
        if (typeof component.fetchCartData === 'function') return component.fetchCartData();
        return fetchCartJson();
      });
    }
    return fetchCartJson();
  }

  function fetchCartJson() {
    return fetch(cartUrl() + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(
      function (response) {
        if (!response.ok) throw new Error('Cart ' + response.status);
        return response.json();
      }
    );
  }

  function setButton(button, state) {
    if (!button) return;
    var label = button.querySelector('[data-sa-label]');
    if (!button.getAttribute('data-sa-original') && label) {
      button.setAttribute('data-sa-original', label.textContent);
    }
    button.classList.remove('is-loading');
    button.disabled = false;
    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
    }
    if (label) {
      if (state === 'added') {
        label.textContent = button.getAttribute('data-sa-added') || 'Adăugat în coș';
        window.setTimeout(function () {
          label.textContent = button.getAttribute('data-sa-original') || label.textContent;
        }, 2200);
      } else if (state === 'idle') {
        label.textContent = button.getAttribute('data-sa-original') || label.textContent;
      }
    }
  }

  function showMessage(form, text) {
    var message = form.querySelector('[data-sa-msg]');
    if (!message) return;
    message.textContent = text || '';
    message.hidden = !text;
    if (text) {
      window.setTimeout(function () {
        message.hidden = true;
      }, 8000);
    }
  }

  function addToCart(form) {
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);
    var sectionIds = [];

    each(document.querySelectorAll('cart-items-component'), function (element) {
      if (element.dataset && element.dataset.sectionId) sectionIds.push(element.dataset.sectionId);
    });
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    var quantity = Number(formData.get('quantity')) || 1;
    setButton(button, 'loading');
    showMessage(form, '');

    return loadEvents().then(function (module) {
      var CartEvent = module && module.CartLinesUpdateEvent;
      var deferred = CartEvent && typeof CartEvent.createPromise === 'function' ? CartEvent.createPromise() : null;

      if (deferred) {
        form.dispatchEvent(
          new CartEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(formData.get('id')), quantity: quantity }],
            promise: deferred.promise,
          })
        );
      }

      return fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.status) {
            setButton(button, 'idle');
            showMessage(form, result.description || result.message || 'Produsul nu a putut fi adăugat.');
            if (deferred) {
              refreshCart()
                .then(function (cart) {
                  deferred.resolve({
                    cart: CartEvent.createCartFromAjaxResponse(cart),
                    detail: { didError: true, items: cart.items, source: 'sa-home', sourceId: form.id, itemCount: quantity },
                  });
                })
                .catch(deferred.reject);
            }
            return;
          }

          form.setAttribute('data-sa-added', '1');
          setButton(button, 'added');

          if (!deferred) {
            window.location.href = cartUrl();
            return;
          }

          return refreshCart().then(function (cart) {
            deferred.resolve({
              cart: CartEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'sa-home',
                sourceId: form.id,
                itemCount: quantity,
                sections: result.sections,
                didError: false,
              },
            });
          });
        })
        .catch(function (error) {
          if (deferred) deferred.reject(error);
          throw error;
        });
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-sa-add]') : null;
    if (!form) return;
    event.preventDefault();
    form.removeAttribute('data-sa-added');
    addToCart(form).catch(function () {
      // Dacă produsul a ajuns deja în coș, nu îl mai trimitem încă o dată.
      if (form.getAttribute('data-sa-added') === '1') {
        setButton(form.querySelector('button[type="submit"]'), 'idle');
        return;
      }
      form.submit();
    });
  });

  /* ---------- Pornire ---------- */
  function init(root) {
    var scope = root || document;
    initZones(scope);
    initCarousels(scope);
    initTabs(scope);
  }

  SAHome.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest) return;
    var wrap = block.closest('[data-sa-zones]');
    var index = block.getAttribute('data-sa-zone');
    if (wrap && wrap.saSelect && index) wrap.saSelect(index);
  });
})();
